document.addEventListener("DOMContentLoaded", function() {
    let timerInterval;
    let timerRunning = false;

    function startTimer(duration, display) {
        clearInterval(timerInterval);

        const savedEndTime = localStorage.getItem('cartTimerEnd');
        const remainingTime = savedEndTime 
            ? Math.floor((parseInt(savedEndTime) - Date.now()) / 1000) 
            : 0;

        const endTime = remainingTime > 0 
            ? parseInt(savedEndTime) 
            : Date.now() + duration * 1000;

        localStorage.setItem('cartTimerEnd', endTime);

        function tick() {
            const remaining = Math.floor((endTime - Date.now()) / 1000);

            if (remaining <= 0) {
                clearInterval(timerInterval);
                localStorage.removeItem('cartTimerEnd');
                display.textContent = "00:00";
                timerRunning = false;
                return;
            }

            let minutes = Math.floor(remaining / 60);
            let seconds = remaining % 60;

            display.textContent =
                (minutes < 10 ? "0" + minutes : minutes) + ":" +
                (seconds < 10 ? "0" + seconds : seconds);
        }

        tick();
        timerInterval = setInterval(tick, 1000);
    }

    function initTimer() {
        const display = document.querySelector('#cart-timer #timer');
        if (!display) return;

        const savedEndTime = localStorage.getItem('cartTimerEnd');
        const remainingTime = savedEndTime 
            ? Math.floor((parseInt(savedEndTime) - Date.now()) / 1000) 
            : 0;

        if (remainingTime > 0) {
            startTimer(remainingTime, display);
            timerRunning = true;
        } else {
            localStorage.removeItem('cartTimerEnd');
            startTimer(10 * 60, display);
            timerRunning = true;
        }
    }

    // Direct runnen bij laden
    initTimer();

    const cartDrawer = document.querySelector('#cart-drawer');
    if (cartDrawer) {
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.attributeName === 'style' || mutation.attributeName === 'class') {
                    const isOpen = 
                        cartDrawer.style.display === 'block' ||
                        cartDrawer.classList.contains('is-open') ||
                        cartDrawer.classList.contains('active') ||
                        cartDrawer.hasAttribute('open');

                    if (isOpen) initTimer();
                }
            });
        });

        observer.observe(cartDrawer, { attributes: true });
    }

    // ✅ Prestige-specifiek event na elke cart update
    document.addEventListener('cart:change', function() {
        timerRunning = false;
        initTimer();
    });
});